import { useContext } from "react";
import { useQuery } from "react-query";
import { UserKeys } from "../keys";
import { SnackbarContext } from "../../hooks/SnackbarContext";
import { getUsers } from "../../services/UserManagementService";

export const useUsersByStore = (storeNumber: string) => {
  const { addSnack } = useContext(SnackbarContext);

  return useQuery(
    [UserKeys.GetUsersByStore, storeNumber],
    (context) => getUsers(storeNumber),
    {
      enabled: !!storeNumber,
      refetchOnWindowFocus: false,
      onError: (_err:any) => {
        addSnack({
          severity: "error",
          message: _err.response?.data?.message ?? "Error retrieving users",
          duration: 3000,
        });
      },
      retry: (failureCount, error: any) =>
        failureCount < 3 && error?.status === 500,
      staleTime: 3000,
    }
  );
};
